// import React, { useEffect, useState } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import DashboardCard2 from 'src/components/shared/DashboardCard2';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import { useNavigate } from 'react-router';
// import { Box } from '@mui/material';
// import WebAppointmentBookingLink from './WebAppointmentBookingLink/WebAppointmentBookingLink';
// import OwnerProfile from './OwnerProfile/OwnerProfile';
// import CombineMasking from './MaskingInformation/CombineMasking';

// const Settings = () => {
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();
//   const { 
//     fetchAOwner, 
//     setOwnerData, 
//     ownerData, 
//     setActiveBranchId, 
//     getBranch, 
//     setBranchData, 
//     branchData 
//   } = useMain();

//   const refreshBranchData = async (branchId) => {
//     try {
//       if (!branchId) return;
//       const res = await getBranch(branchId);
//       if (res.statusCode === 200) {
//         setBranchData((prev) => ({ ...prev, ...res.data }));
//       }
//     } catch (error) {
//       console.error("Error fetching branch data:", error);
//     }
//   };

//   const refreshData = async (id) => {
//     try {
//       setLoading(true);
//       const res = await fetchAOwner(id);
//       if (res?.statusCode === 200) {
//         const owner = res?.data;

//         if (owner?.activeStatus?.toLowerCase() !== 'active') {
//           localStorage.removeItem('salon-admin');
//           setActiveBranchId(null);
//           setBranchData({});
//           setOwnerData({});
//           navigate('/auth/login');
//           return;
//         }

//         setOwnerData(owner);
//         const activeBranch = owner?.branch?.find((item) => item?.activeStatus === 'APPROVED');
//         setActiveBranchId(activeBranch?._id || null);
//         refreshBranchData(activeBranch?._id);

//         localStorage.setItem('salon-admin', JSON.stringify(owner._id));
//       }
//     } catch (error) {
//       console.error("Error fetching owner data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const storedOwnerId = JSON.parse(localStorage.getItem('salon-admin'));
//     if (storedOwnerId) {
//       refreshData(storedOwnerId);
//     } else {
//       setLoading(false);
//     }
//   }, []);

//   return (
//     <PageContainer title="Settings" description="This is the settings page">
//       <DashboardCard2 title="Settings">
//         {loading ? (
//           <ShowLoader />
//         ) : (
//           <Box display="flex" flexDirection="column" gap="10px">
//             <OwnerProfile 
//               data={ownerData} 
//               refreshData={refreshData}
//               selectedTemplate={branchData?.selectedBillTemplate || 1}
//             />
//             <WebAppointmentBookingLink />
//             <CombineMasking data={ownerData} refreshData={refreshData} />
//           </Box>
//         )}
//       </DashboardCard2>
//     </PageContainer>
//   );
// };

// export default Settings;

import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { useNavigate } from 'react-router';
import { Box } from '@mui/material';
import WebAppointmentBookingLink from './WebAppointmentBookingLink/WebAppointmentBookingLink';
import OwnerProfile from './OwnerProfile/OwnerProfile';
import CombineMasking from './MaskingInformation/CombineMasking';
import OTPSettings from './OTPSettings'; // Import the new component
import WhatsAppIntegration from './Whatsappintigration';

const Settings = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { 
    fetchAOwner, 
    setOwnerData, 
    ownerData, 
    setActiveBranchId, 
    getBranch, 
    setBranchData, 
    branchData 
  } = useMain();

  const refreshBranchData = async (branchId) => {
    try {
      if (!branchId) return;
      const res = await getBranch(branchId);
      if (res.statusCode === 200) {
        setBranchData((prev) => ({ ...prev, ...res.data }));
      }
    } catch (error) {
      console.error("Error fetching branch data:", error);
    }
  };

  const refreshData = async (id) => {
    try {
      setLoading(true);
      const res = await fetchAOwner(id);
      if (res?.statusCode === 200) {
        const owner = res?.data;

        if (owner?.activeStatus?.toLowerCase() !== 'active') {
          localStorage.removeItem('salon-admin');
          setActiveBranchId(null);
          setBranchData({});
          setOwnerData({});
          navigate('/auth/login');
          return;
        }

        setOwnerData(owner);
        const activeBranch = owner?.branch?.find((item) => item?.activeStatus === 'APPROVED');
        setActiveBranchId(activeBranch?._id || null);
        refreshBranchData(activeBranch?._id);

        localStorage.setItem('salon-admin', JSON.stringify(owner._id));
      }
    } catch (error) {
      console.error("Error fetching owner data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedOwnerId = JSON.parse(localStorage.getItem('salon-admin'));
    if (storedOwnerId) {
      refreshData(storedOwnerId);
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <PageContainer title="Settings" description="This is the settings page">
      <DashboardCard2 title="Settings">
        {loading ? (
          <ShowLoader />
        ) : (
          <Box display="flex" flexDirection="column" gap="10px">
            <OwnerProfile 
              data={ownerData} 
              refreshData={refreshData}
              selectedTemplate={branchData?.selectedBillTemplate || 1}
            />
            <WebAppointmentBookingLink data={ownerData} refreshData={refreshData} />
            <CombineMasking data={ownerData} refreshData={refreshData} />
            {/* Add OTP Settings Component */}
            <OTPSettings data={ownerData} refreshData={refreshData} />
            <WhatsAppIntegration data={ownerData} refreshData={refreshData} />
          </Box>
        )}
      </DashboardCard2>
    </PageContainer>
  );
};

export default Settings;